import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

export const useGetPurchaserReport = () => {
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const Api = useApi()
  const initialFilters = {
    sort_by: 'total_profit/-1',
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), // includes today,
  }

  const {filters, onDateChange, onSortingChange} = useFilters(initialFilters, {sortType: 'number'})

  const {data: response, isFetching} = Api.useGetQuery('/analytics/profitability/purchasers', {
    queryId: 'purchaser-report',
    filters,
    isToast: false,
    isErrorPageRedirection: false,
  })

  return {
    reportData: response?.data || [],
    isLoading: isFetching,
    filters,
    onSortingChange,
    handlePurchaserReportDateChange: onDateChange,
    pagination: response?.meta?.pagination || {},
  }
}
